import { useSearchParams } from 'react-router-dom';
import { SystemLogoIcon } from 'static/icons';
import { ProductsCodeList } from 'components';
import * as S from './styles';

export function OrdersCodeListPage() {
  const [searchParams] = useSearchParams();

  const codes = searchParams.get('codigos')?.split(',');

  return (
    <S.Wrapper>
      <S.Header>
        <S.LogoWrapper>
          <SystemLogoIcon />
        </S.LogoWrapper>
      </S.Header>

      <ProductsCodeList codes={codes} />
    </S.Wrapper>
  );
}
